module.exports = __webpack_public_path__ + "static/media/bear_bg.b4c09ae1.png";